import devapis from "./devapis";
export const stagingapis = {
    ...devapis,
}

export default stagingapis;